module.exports = __webpack_public_path__ + "img/bounty_skill_big.58855e58.png";